import { Link, useLocation } from "react-router-dom";
import { Shield } from "lucide-react";

export const Navbar = () => {
  const { pathname } = useLocation();
  return (
    <header
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-slate-950/85 border-b border-slate-800/70"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2.5 group"
          data-testid="navbar-brand-logo"
        >
          <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-lg bg-cyan-500/10 border border-cyan-500/30">
            <Shield className="h-4.5 w-4.5 text-cyan-400" strokeWidth={2.2} />
            <span className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-emerald-400 pulse-dot" />
          </span>
          <div className="leading-tight">
            <div className="font-display font-bold text-slate-50 text-base tracking-tight">
              ShieldPilot
            </div>
            <div className="text-[10px] uppercase tracking-widest text-cyan-400/80 font-semibold">
              Passive Security Audit
            </div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-7 text-sm text-slate-400">
          <Link
            to="/"
            className={`hover:text-cyan-300 transition-colors ${pathname === "/" ? "text-cyan-300" : ""}`}
            data-testid="nav-link-scanner"
          >
            Scanner
          </Link>
          <a href="/#checks" className="hover:text-cyan-300 transition-colors" data-testid="nav-link-checks">
            Checks
          </a>
          <a href="/#safety" className="hover:text-cyan-300 transition-colors" data-testid="nav-link-safety">
            Safety
          </a>
          <Link
            to="/dashboard"
            className={`hover:text-cyan-300 transition-colors ${pathname.startsWith("/dashboard") ? "text-cyan-300" : ""}`}
            data-testid="nav-link-history"
          >
            History
          </Link>
        </nav>
        <div className="hidden sm:flex items-center gap-2 text-[11px] text-slate-400">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-400 pulse-dot" />
          <span className="uppercase tracking-wider">Free tier · Non-destructive engine</span>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
